var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00fca3",
    d: "M21.6 6.781 14.734 0H4.05C2.976 0 1.946.421 1.186 1.172S0 2.939 0 4v22.667h21.6zM2.7 24V4c0-.354.142-.693.395-.943a1.36 1.36 0 0 1 .955-.391h9.45V8h5.4v16zM27 12v20H6.75v-2.667H24.3v-20z"
  })));
};
export default SvgCopyIcon;